import { Headline, Text } from '@vkontakte/vkui';
import throttle from 'lodash.throttle';
import React, { type FC } from 'react';
import { useSelector } from 'react-redux';
import type { FakeDoorTemplateData } from 'reactApp/modules/promoNew/types';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { CancelIcon } from 'reactApp/ui/VKUIIcons';

import styles from './Content.css';

interface ContentProps {
    closable: boolean;
    templateData: FakeDoorTemplateData;
    handleHoverPromo: () => void;
    handleHoverButton: () => void;
    handleClickButton: () => void;
    handleHoverCancel: () => void;
    handleClickCancel: () => void;
}

export const Content: FC<ContentProps> = ({
    closable,
    templateData,
    handleHoverPromo,
    handleHoverButton,
    handleClickButton,
    handleHoverCancel,
    handleClickCancel,
}) => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const { title, text, buttons, image } = templateData;

    return (
        <div className={styles.notify} onPointerEnter={throttle(handleHoverPromo, 3000)}>
            {closable && (
                <button
                    className={styles.close}
                    type="button"
                    onClick={handleClickCancel}
                    onPointerEnter={throttle(handleHoverCancel, 3000)}
                >
                    <CancelIcon />
                </button>
            )}

            {image && <img className={styles.image} src={isDarkTheme ? image.dark : image.light} />}

            <div className={styles.content}>
                <Headline level="1" className={styles.headline}>
                    {title}
                </Headline>
                <Text className={styles.text}>{text}</Text>

                {buttons?.complete && (
                    <Button
                        primary
                        theme="octavius"
                        className={styles.button}
                        onClick={handleClickButton}
                        onPointerEnter={throttle(handleHoverButton, 3000)}
                        sizeMode={ButtonSizeMode.small}
                    >
                        {buttons.complete}
                    </Button>
                )}
            </div>
        </div>
    );
};
